export default {
  BLACK: '#000000',
  WHITE: '#FFFFFF',
  TEXT: '#202020',
  GREY: '#F5F5F5',
  GREEN: '#009699',
};
